import { useDispatch, useSelector } from "react-redux";
import SortByIcon from "../../assets/icons/sortByIcon.svg";
import styles from "./FilterButton.module.scss";
import { AnalyticsTypeMap, SortByNameMap } from "../../constants";
import { sendAnalyticsEvent } from "../../lib/postMessage";
import ToolTip from "../OnboardingPopup/components/ToolTip";
import { FILTERS, OPEN } from "../../constants/analytics";

export default function FilterButton() {
  const { prefetchedFilters, onboardingStep } = useSelector(
    (state) => state.filter
  );
  const dispatch = useDispatch();

  const filterType = SortByNameMap.get(prefetchedFilters["sortBy"]);

  const handleFilter = (filterView) => {
    dispatch({ type: "SET_ACTIVE_FILTER_VIEW", payload: filterView });
    sendAnalyticsEvent({
      event: FILTERS,
      type: AnalyticsTypeMap.get(filterView) ?? filterView,
      action: OPEN,
    });
  };

  return (
    <>
      <button
        className={`${styles.filterButton} ${
          onboardingStep === 6 ? styles["filterButton--highlighted"] : ""
        }`}
        aria-label={`filter-button-${name}`}
        onClick={() => handleFilter("sortBy")}
      >
        <img src={SortByIcon} alt="Sort By" />
        <span>{filterType}</span>
      </button>
      {/* If onboarding is active then we show the ToolTip relative to the SortBy Filter */}
      {onboardingStep === 6 ? <ToolTip /> : null}
    </>
  );
}
